import React, { useState, useEffect, useRef } from "react";
import SbEditable from "storyblok-react";

const LogoClouds = ({ blok }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Disconnect to avoid performance issues
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div
        id="awards"
        ref={ref}
        className="bg-white pt-16 pb-20 px-6 lg:pt-24 lg:pb-28"
      >
        <div className="max-w-7xl mx-auto text-center">
          <div className="uppercase subtitle text-orange">{blok.label}</div>
          <div className="flex justify-center items-center mb-5 lg:mb-7">
          <img src={blok?.power_icon?.filename} alt={blok?.power_icon?.alt} className="w-10 h-10" />
          </div>
          <h2 className="h2">{blok.title}</h2>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 overflow-hidden">
            {blok.logos.map((item, index) => (
              <div
                className={`col-span-1 overflow-hidden flex justify-center sm:py-8 py-4 sm:px-8 px-4`}
                key={item.id}
                
              >
                <img
                  src={item?.filename}
                  loading="lazy"
                  alt={item?.alt}
                  className={`block m-auto transform transition-transform duration-700 ${
                    isVisible
                      ? "translate-y-0 opacity-100"
                      : "translate-y-full opacity-0"
                  }`}
                  style={{ transitionDelay: `${index * 0.1}s` }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default LogoClouds;
